import { NSARouterMakerResult } from "namirasoft-account-react";
import { AlarmProps } from "../AlarmProps";
import { AlarmLayout } from "../AlarmLayout";
import { AlarmEntities } from "../AlarmEntities";

export interface AlarmListPageProps extends NSARouterMakerResult, AlarmProps
{ }

function AlarmListPage(props: AlarmListPageProps) 
{
	return (
		<AlarmLayout {...props}
			action={{
				title: "",
				description: "A list of alarms you’ve set to stay informed about important activities.",
				menus: {}
			}}
			pages={{
				entity: AlarmEntities.alarm(props),
				list: {
					ui: {}
				}
			}}
		>
			<></>
		</AlarmLayout >
	);
}

export default AlarmListPage;